<template>
  <div class="container">
    <div class="generator">
      <Logo />

      <div class="content">
        <div class="form">
          <h3>Build Your Email Signature</h3>

          <div class="fields">
            <div class="field">
              <label for="name">Full Name <span class="required">*</span></label>
              <input
                v-model="data.employee.name"
                id="name"
                type="text"
                placeholder="e.g. John Doe"
                @input="updatePreview"
              >
            </div>
          </div>

          <div class="fields">
            <div class="field">
              <label for="role">Job Role / Title <span class="required">*</span></label>
              <input
                v-model="data.employee.role"
                id="role"
                type="text"
                placeholder="e.g. Digital Marketing Manager"
                @input="updatePreview"
              >
            </div>
          </div>

          <div class="fields">
            <div class="field">
              <label for="phone">Phone Number</label>
              <input
                v-model="data.employee.phone"
                id="phone"
                type="text"
                placeholder="01482 421526"
                @input="updatePreview"
              >
            </div>

            <div class="field">
              <label for="email">Email Address <span class="required">*</span></label>
              <input
                v-model="data.employee.email"
                id="email"
                type="text"
                placeholder="john@43clicksnorth.co.uk"
                @input="updatePreview"
              >
            </div>
          </div>

          <div class="field">
            <label for="image">Profile Photo URL <span class="required">*</span></label>
            <input
              v-model="data.employee.image"
              id="image"
              type="text"
              placeholder="https://i.ibb.co/abc123/your-photo.png"
              @input="updatePreview"
            >
            <small>
              Upload your photo to
              <a href="https://cloudinary.com/" target="_blank" style="color:#0cbcfa">Cloudinary.com</a>
              and paste the <strong>Direct Link</strong> here.<br>
              Ensure the image is exactly 360x449px in size.
            </small>
          </div>

          <div class="fields">
            <div class="field">
              <label for="twitter">Twitter URL (optional)</label>
              <input
                v-model="data.twitter"
                id="twitter"
                type="text"
                placeholder="https://twitter.com/yourhandle"
                @input="updatePreview"
              >
            </div>

            <div class="field">
              <label for="linkedin">LinkedIn URL (optional)</label>
              <input
                v-model="data.linkedin"
                id="linkedin"
                type="text"
                placeholder="https://linkedin.com/in/yourprofile"
                @input="updatePreview"
              >
            </div>
          </div>

          <i>Twitter & LinkedIn urls default to 43 Clicks North pages. Use the fields above to override.</i>
          <br><br>
        </div>

        <div class="instructions">
          <h4>How to add to Gmail:</h4>
          <ol>
            <li>Fill in your details</li>
            <li>Click "Copy for Gmail"</li>
            <li>In Gmail → Settings (cog) → See all settings</li>
            <li>Scroll to 'Signature' section</li>
            <li>Press <span>Ctrl + A</span> then <span>Ctrl + V</span></li>
            <li>Click Save Changes</li>
          </ol>
        </div>
      </div>
    </div>

    <!-- Preview + buttons always visible -->
    <div class="output-container visible">
      <div class="preview">
        <Output :data="displayData" ref="output" :publicPath="publicPath" />
        <textarea v-model="html" ref="html" style="opacity: 0" />
      </div>

      <div class="actions">
        <button @click="copyHTML" class="btn">Copy HTML</button>
        <button @click="copySelect" class="btn">Copy for Gmail</button>
        <Prompt :class="[prompt ? 'visible' : '']" />
      </div>
    </div>
  </div>
</template>

<script>
import Output from './Output.vue'
import Prompt from './Prompt.vue'
import Logo from '../assets/logo.svg'

export default {
  name: 'Generator',
  components: { Output, Logo, Prompt },
  data: () => {
    const publicPath = process.env.VUE_APP_BASE_URL || ''

    return {
      publicPath,
      prompt: false,
      data: {
        employee: {
          name: '',
          role: '',
          phone: '',
          email: '',
          image: ''
        },
        linkedin: '',
        twitter: ''
      },
      html: ''
    }
  },
  computed: {
    displayData() {
      const userImage = (this.data.employee.image || '').trim()
      const imageUrl = userImage || `${this.publicPath}assets/portrait_placeholder.png`

      return {
        ...this.data,
        employee: {
          ...this.data.employee,
          image: imageUrl,
					name: this.data.employee.name || 'John Doe',
					role: this.data.employee.role || 'Superstar employee',
					phone: this.data.employee.phone || '01482 421526',
					email: this.data.employee.email || 'john@43clicksnorth.co.uk'
        }
      }
    }
  },
  watch: {
    prompt(newVal) {
      if (!newVal) return
      setTimeout(() => { this.prompt = false }, 1500)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updatePreview()
    })
  },
  methods: {
    updatePreview() {
      if (this.$refs.output) {
        this.html = this.parseHTML()
      }
    },
    parseHTML() {
      return this.$refs.output.$el.querySelector('table').outerHTML.replace(/<!---->/g, '')
    },
    copyHTML() {
      const html = this.$refs.output.$el.innerHTML
      navigator.clipboard.writeText(html)
        .then(() => {
          this.prompt = true
        })
    },
    copySelect() {
      if (!window.getSelection) return
      let range = document.createRange()
      range.selectNode(this.$refs.output.$el.querySelector('table'))
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
      document.execCommand('copy')
      this.prompt = true
    }
  }
}
</script>
